import { styled } from '@mui/material';
import { ReactComponent as IconUserPlus } from '../../../assets/images/userPlus.svg';

export const StyledIconUserPlus = styled(IconUserPlus)(() => ({
  cursor: 'pointer',
  height: '20px',
  width: '20px',
}));
